/**
 * CLUBWELL — Cart badge sync (Shopify source of truth)
 * Fixes: badge showing stale count after Recharge removes items / drawer closes.
 *
 * Updates:
 *  - Header badge: .cart-button__quantity (your screenshot)
 *  - Drawer header count: [data-header-cart-count]
 *  - Drawer attribute: #site-cart-sidebar[data-cart-items]
 */
(function () {
  // Prevent double-registration if theme/app injects this more than once
  if (window.__clubwellCartSyncInstalled) return;
  window.__clubwellCartSyncInstalled = true;

  async function fetchCartCount() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();
    return Number(cart.item_count || 0);
  }

  function applyCountToUI(count) {
    // ✅ Your real badge
    document.querySelectorAll('.cart-button__quantity').forEach(el => {
      el.textContent = String(count);
    });

    // Drawer header title count
    document.querySelectorAll('[data-header-cart-count]').forEach(el => {
      el.textContent = String(count);
    });

    // Drawer attribute (some logic uses this)
    const drawer = document.getElementById('site-cart-sidebar');
    if (drawer) drawer.setAttribute('data-cart-items', String(count));
  }

  // Public function (apps/other scripts can call it)
  window.syncHeaderCartCount = async function syncHeaderCartCount() {
    try {
      const count = await fetchCartCount();
      applyCountToUI(count);
      return count;
    } catch (err) {
      console.log('Cart sync error', err);
      return null;
    }
  };

  // Optional: keep badge accurate on initial load too
  window.syncHeaderCartCount();
})();